import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import accounting from "accounting";
import ExpressAdvice from "./ExpressAdvice";
import Customer from "./Customer";
import Scooter from "./Scooter";
import _ from "lodash";
import ItemSection from "./ItemSection";
import NoteSection from "./NoteSection";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Icon from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faHandPaper,
  faWrench,
  faSyncAlt,
  faTimes
} from "@fortawesome/fontawesome-free-solid";
import {
  transformLowdash,
  continueMessages,
  getBreakpointFromWidth,
} from "../helpers/index";
import { isEmpty } from "lodash";
import Button from "./CustomButton";
import {
  branch,
  withProps,
  compose,
  renderNothing,
  setDisplayName,
  withHandlers,
} from "recompose";
import EventSection from "./EventSection";
import TotalSection from "./TotalSection";
import DiscountSection from "./DiscountSection";
import ContactSection from "./ContactSection";
import { connect } from "react-redux";
import { actions as contractsActions, selectors } from "../modules/contracts";
import WithTabs from "./WithTabs";
import classnames from "classnames";
import WithTotals from "./WithTotals";
import { getCompletedItems } from "../modules/items";
import WithResizeListener from "../containers/WithResizeListener/index";
import useTitleSetter from "./useTitleSetter";

import { ListGroup, ListGroupItem, Collapse } from "reactstrap";
import { Queue } from "./TrackSection";
import { Timeline } from "./ContractList";
import StripeCheckoutForm from './StripeCheckoutForm'

const propTypes = {
  contract: PropTypes.object.isRequired,
};

const getId = ({ id }) => id;

const withHoldProps = (displayName) =>
  compose(
    setDisplayName(displayName),
    branch(
      ({ role, contract: { aasm_state } }) =>
        !aasm_state || !(role === "staff" && aasm_state === "in_service"),
      renderNothing
    ),
    withProps(
      ({
        submittingContract,
        contract: { aasm_state },
        confirmedItems,
        completedItems,
      }) => ({
        disabled:
          submittingContract ||
          (["in_service"].includes(aasm_state) &&
            completedItems.length >= confirmedItems.length),
      })
    )
  );

const ResumeButton = compose(
  setDisplayName("ResumeButton"),
  branch(
    ({ role, contract: { aasm_state } }) =>
      !(role === "staff" && ["hold", "waiting_for_parts"].includes(aasm_state)),
    renderNothing
  ),
  withProps(
    ({
      submittingContract,
      contract: { aasm_state },
      confirmedItems,
      completedItems,
    }) => ({
      disabled:
        submittingContract ||
        (["in_service"].includes(aasm_state) &&
          completedItems.length >= confirmedItems.length),
    })
  )
)(({ onClickTransition, disabled }) => (
  <div className="col-md-auto col-sm-12 px-xl-1 my-1 btn-continue">
    <Button
      type="button"
      fill
      block
      disabled={disabled}
      onClick={onClickTransition("resume")}
      color="primary"
    >
      Mark As In Service <FontAwesomeIcon icon={faSyncAlt} />
    </Button>
  </div>
));

const RefundButton = compose(
  setDisplayName("RefundButton"),
  branch(
    ({ role, contract: { aasm_state } }) =>
      !(role === "staff" && [ "waiting_for_service"].includes(aasm_state)),
    renderNothing
  ),
  withProps(
    ({
      submittingContract,
      contract: { aasm_state },
    }) => ({
      disabled:
        submittingContract ||
        ["in_service"].includes(aasm_state) ,
    })
  )
)(({ onClickTransition, disabled }) => (
  <div className="col-md-auto col-sm-12 px-xl-1 my-1 btn-continue">
    <Button
      type="button"
      fill
      block
      disabled={disabled}
      onClick={onClickTransition("refund")}
      color="primary"
    >
      Cancel & Refund <FontAwesomeIcon icon={faTimes} />
    </Button>
  </div>
));

const OnHoldButton = withHoldProps("OnHoldButton")(
  ({ onClickTransition, disabled }) => (
    <div className="col-md-auto col-sm-12 px-xl-1 my-1 btn-continue">
      <Button
        type="button"
        //fill
        block
        disabled={disabled}
        onClick={onClickTransition("hold")}
        color="primary"
      >
        Mark As On Hold <FontAwesomeIcon icon={faHandPaper} />
      </Button>
    </div>
  )
);

const WaitingForPartsButton = withHoldProps("WaitingForPartsButton")(
  ({ onClickTransition, disabled }) => (
    <div className="col-md-auto col-sm-12 px-xl-1 my-1 btn-continue">
      <Button
        type="button"
        //fill
        block
        disabled={disabled}
        onClick={onClickTransition("waiting_parts")}
        color="primary"
      >
        Mark As Waiting For Parts <FontAwesomeIcon icon={faWrench} />
      </Button>
    </div>
  )
);

const ContinueButton = compose(
  setDisplayName("ContinueButton"),
  branch(
    ({ role, contract: { aasm_state } }) =>
      !(
        (role === "staff" &&
          !["completed", "hold", "waiting_for_parts", "cancelled"].includes(aasm_state)) ||
        (role === "customer" && aasm_state === "customer_confirmation_needed")
      ),
    renderNothing
  ),
  withProps(
    ({
      submittingContract,
      currentContract,
      confirmedItems,
      requiredItems,
      completedItems,
    }) => ({
      disabled:
        !currentContract ||
        submittingContract ||
        (["in_diagnostic", "approve_diagnostic"].includes(
          currentContract.aasm_state
        ) &&
          isEmpty(requiredItems)) ||
        (["customer_confirmation_needed"].includes(
          currentContract.aasm_state
        ) &&
          (isEmpty(requiredItems)
            ? isEmpty(confirmedItems)
            : _.difference(requiredItems.map(getId), confirmedItems.map(getId))
                .length !== 0)) ||
        (["in_service"].includes(currentContract.aasm_state) &&
          completedItems.length < confirmedItems.length),
      continueMessage: continueMessages[currentContract.aasm_state],
    })
  )
)(({ onClickTransition, disabled, continueMessage, role }) => (
  <div
    className={
      role === "staff"
        ? "col-md-auto col-sm-12 px-xl-1 mr-2 btn-continue"
        : "col-md-auto col-sm-12 px-xl-1 btn-continue btn-payment"
    }
  >
    <Button
      className={
        role === "staff"
          ? "btn-fill btn-continue"
          : "btn-fill btn-continue btn-payment"
      }
      fill
      block
      type="button"
      color="primary"
      disabled={disabled}
      onClick={onClickTransition("continue")}
    >
      {continueMessage} <FontAwesomeIcon icon={faArrowRight} />
    </Button>
  </div>
));

const ButtonSection = ({ separator, ...props }) => (
  <>
    <ContinueButton {...props} />
    <OnHoldButton {...props} />
    <WaitingForPartsButton {...props} />
    <ResumeButton {...props} />
    <CustomerPaymentButton />
  </>
);
const ButtonSectionStaff = ({ separator, ...props }) => (
  <>
    {separator && <hr />}
    <div className=" btn-payment-staff">
      <OnHoldButton {...props} />
      <WaitingForPartsButton {...props} />
      <ResumeButton {...props} />
      <ContinueButton {...props} />
      <RefundButton {...props}/> 
      <CustomerPaymentButton />
    </div>
  </>
);
const CustomerPaymentButton = compose(
  setDisplayName("CustomerPaymentButton"),
  connect(
    (state) => ({
      contract: state.contracts.currentContract,
      items: getCompletedItems(state),
      discounts: state.discounts.discounts,
      role: state.settings.role,
      loading: selectors.isLoadingCreatePayment(state),
      failure: selectors.getFailureCreatePayment(state),
      onlinePay: state.contracts.currentContract.dealer.online_pay,
    }),
    {
      createRecorderPayment: contractsActions.createRecorderPayment,
      createPaymentIntent: contractsActions.createPaymentIntent,
      updateContract: contractsActions.updateContract
    }
  ),
  withHandlers({
    onToken: ({ updateContract, contract }) => token => {
      const token_card_id = typeof token === "object" ? token.id : token;
      const data = {
          continue: true,
          customer_attributes: {
            id: contract.customer.id,
            token_card_id
          }
      };
      updateContract({
        dealer_id: contract.dealer.id,
        data,
        contract_id: contract.tracking_number
      }).then(({ response }) => {
        if (response) {
          alert("Your payment has been received");
        }
      });
    }
  }),
  WithTotals,
  branch(
    ({ contract }) =>
      _.get(contract, "aasm_state", "") !== "waiting_for_payment",
    renderNothing
  ),
  branch(({ role }) => role !== "customer", renderNothing)
)(
  ({
    contract,
    finalTotal,
    createRecorderPayment,
    createPaymentIntent,
    loading,
    failure,
    role,
    onlinePay,
    onToken
  }) => {
    if (onlinePay) {
      // const onProcessPayment = useCallback(
      //   (response) => {
      //     if (contract && response && response.StatusCode === "00") {
      //       const data = {
      //         payment: {
      //           transaction_id: response.TransactionId,
      //           card_data: {
      //             card_type: response.CardType,
      //             pan: response.MaskedPAN,
      //             secure_payment_account_data: response.PaymentAccountDataToken,
      //             expire: response.Expire.split("/").join(""),
      //             main: true,
      //           },
      //         },
      //       };
      //       createRecorderPayment({
      //         contract_id: contract.tracking_number,
      //         dealer_id: _.get(contract, "dealer.id", ""),
      //         data,
      //       });
      //     }
      //   },
      //   [contract, createRecorderPayment]
      // );

      // useEffect(() => {
      //   window.onProcessPayment = onProcessPayment;
      //   const script = document.createElement("script");
      //   script.onload = function() {
      //     if (window.Velocity) {
      //       window.Velocity.autoinit();
      //     }
      //   };
      //   script.src = process.env.REACT_APP_NAB_VELOCITY_URL;
      //   document.body.appendChild(script);
      //   return () => {
      //     window.onProcessPayment = null;
      //   };
      // }, [onProcessPayment]);
      // const btnClass =
      //   role === "staff"
      //     ? "btn btn-primary btn-fill velocity-button btn-payment-staff"
      //     : "btn btn-primary btn-fill velocity-button btn-payment";
      return (
        <>
          {/* <button
            disabled={loading}
            className={btnClass}
            data-terminal-profile-id={
              process.env.REACT_APP_NAB_VELOCITY_PROFILE
            }
            data-amount={finalTotal}
            //data-email={email}
            //data-billing-name={`${_.get(contract, "customer.first_name", "")} ${_.get(contract, "customer.last_name", "")}`}
            data-callback-function="onProcessPayment"
          >
            Pay Order <FontAwesomeIcon icon={faCreditCard} /> 
            
          </button>*/}
          <StripeCheckoutForm 
            total={contract.total_cost_contract} 
            createPaymentIntent={createPaymentIntent} 
            contract={contract} 
            dealer={contract.dealer}
            onToken={onToken}
          />
          {failure && <div className="alert alert-danger">{failure}</div>}
        </>
      );
    } else {
      return null;
    }
  }
);

export const PrimaryTabs = compose(
  setDisplayName("PrimaryTabs"),
  WithTabs
)(({ tab, onSetTab }) => {
  return (
    <div>
      <Nav tabs fill>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "1" })}
            onClick={onSetTab("1")}
          >
            Totals
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "2" })}
            onClick={onSetTab("2")}
          >
            Discounts
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent className="content-style totalSection " activeTab={tab}>
        <TabPane tabId="1">
          <TotalSection />
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col>
              <DiscountSection />
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
});

export const SecondaryTabs = compose(
  setDisplayName("SecondaryTabs"),
  WithTabs
)(({ tab, onSetTab, events, props, location, history }) => {
  const show = (x) => {
    let tabName = x;
    if (history) {
      if (location.search.includes("show=")) {
        tabName = location.search.substr(location.search.indexOf("show=") + 5);
      }
    }
    switch (tabName) {
      case "notes":
        tab = "2";
        onSetTab("2");
        break;
      case "history":
        tab = "3";
        onSetTab("3");
        break;
      case "contacts":
        tab = "4";
        onSetTab("4");
        break;
      case "services":
        tab = "1";
        onSetTab("1");
        break;
      default:
        break;
    }
  };

  const clicktab = (x) => {
    switch (x) {
      case "notes":
        tab = "2";
        onSetTab("2");
        if (history) {
          history.push("?show=notes");
        }
        break;
      case "history":
        tab = "3";
        onSetTab("3");
        if (history) {
          history.push("?show=history");
        }
        break;
      case "contacts":
        tab = "4";
        onSetTab("4");
        if (history) {
          history.push("?show=contacts");
        }
        break;
      case "services":
        tab = "1";
        onSetTab("1");
        if (history) {
          history.push("?show=services");
        }
        break;
      default:
        break;
    }
    show(x);
  };
  const detailed= location.pathname.includes("new")||location.pathname.includes("edit")
  return (
    <div>
      {!detailed && (<Nav tabs fill>
        {show()}
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "1" })}
            onClick={() => clicktab("services")}
          >
            Services
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "2" })}
            onClick={() => clicktab("notes")}
          >
            Notes
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "3" })}
            onClick={() => clicktab("history")}
          >
            History
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "4" })}
            onClick={() => clicktab("contacts")}
          >
            Contacts
          </NavLink>
        </NavItem>
      </Nav>)}
      {detailed && (<Nav tabs fill>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "1" })}
            onClick={onSetTab("1")}
          >
            Services
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "2" })}
            onClick={onSetTab("2")}
          >
            Notes
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "3" })}
            onClick={onSetTab("3")}
          >
            History
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: tab === "4" })}
            onClick={onSetTab("4")}
          >
            Contacts
          </NavLink>
        </NavItem>
      </Nav>)}
      

      <TabContent className="content-style" activeTab={tab}>
        <TabPane tabId="1">
          <ItemSection />
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col sm="12">
              <NoteSection />
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <div className="tab-section">
            <EventSection {...props} events={events} />
          </div>
        </TabPane>
        <TabPane tabId="4">
          <Row>
            <Col>
              <ContactSection />
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
});

const EnhancedCustomer = compose(
  setDisplayName("EnhancedCustomer"),
  connect((state) => ({
    role: state.settings.role,
  })),
  branch(({ role }) => role === "customer", renderNothing)
)((props) => (
  <div className="customer">
    <Customer {...props} />
  </div>
));

const ContractDetailed = compose(
  setDisplayName("ContractDetailed"),
  WithResizeListener,
  connect((state) => ({
    role: state.settings.role,
  }))
)((props) => {
  const {
    width,
    contract: {
      tracking_number,
      labor_rate,
      warranty,
      aasm_state,
      customer,
      scooter,
      events,
      key_tag,
      repair_order_no
    },
    failSubmitContract,
    role,
  } = props;
  console.log("customer: ", customer)
  const contractInfo = (
    <div className="row">
      <div className="col-md-12">
        <label>
          Labor Rate: <b>{accounting.formatMoney(labor_rate)}/Hour</b>
        </label>
        &nbsp;
        <label>
          Warranty: <b>{warranty}</b>
        </label>
        &nbsp;
        <label>
          Repair Order: <b>{repair_order_no}</b>
        </label>
        &nbsp;
        <label>
          Customer ID: <b>{customer.cust_identifier}</b>
        </label>
      </div>
    </div>
  );
  const buttons = (
    <>
      {role === "staff" ? (
        <ButtonSectionStaff {...props} />
      ) : (
        <ButtonSection {...props} />
      )}
      {failSubmitContract && <Alert color="danger">{failSubmitContract}</Alert>}
    </>
  );
  const breakpoint = getBreakpointFromWidth(width);
  const isSmallScreen = ["xs", "sm"].includes(breakpoint);
  useTitleSetter(`Contract #${tracking_number}`);
  const expressAdStates = [
    // "pending_diagnostic",
    // "scheduled_scooter_pickup",
    // "in_diagnostic",
    // "approve_diagnostic",
    "customer_confirmation_needed",
  ];
  const [toggledOn, setToggledOn] = useState(false);
  const toggle = () => {
    setToggledOn(!toggledOn);
  };
  const styleTracker =
    props.currentContract.queue_position === 0 &&
    !expressAdStates.includes(props.currentContract.aasm_state)
      ? "col-12 pt-2 px-2"
      : "col-auto pt-2 px-2";
  const styleTrackerAndQueue =
    props.currentContract.queue_position !== 0 &&
    !expressAdStates.includes(props.currentContract.aasm_state)
      ? "col-9 pt-2 px-2"
      : styleTracker;

  if (isSmallScreen && (role === "customer" || role === "contact")) {
    return (
      <>
        <div className="row">
          <EnhancedCustomer customer={customer} />
          {/* <div className="col-12 mb-1">
            <div className="contract-state">{transformLowdash(aasm_state)}</div>
          </div> */}
        </div>

        <div className="row">
          <ListGroup className="scooter-info" flush>
            <ListGroupItem className="scooter">
              <div className=" mb-2" onClick={toggle}>
                <label>
                  Contract details{" "}
                  <Icon icon={toggledOn ? "chevron-up" : "chevron-down"} />
                </label>
                <Collapse isOpen={toggledOn}>
                  <Scooter scooter={scooter} keyTag={key_tag} />
                  <div className="mb-2 selectable">{contractInfo}</div>
                </Collapse>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>

        <div className="card mb-3">
          <div className="col-12">
            <div className="row   align-items-center overflow-hidden">
              {props.currentContract.queue_position > 0 && (
                <div className="w-20 col-md-12 py-3 px-0 justify-content-center">
                  {Queue(props.currentContract.queue_position, "horizontal")}{" "}
                </div>
              )}
              <div className="w-60 col-md-12 pt-2 px-2 border border-right-0 border-left-0 overflow-auto">
                <label className="pb-3 px-2">
                  <b>Tracker</b>
                </label>
                <div className="w-100">
                  <Timeline
                    state_position={props.currentContract.state_position}
                    contract_states={props.currentContract.contract_states}
                  />
                </div>
              </div>
              {expressAdStates.includes(props.currentContract.aasm_state) && (
                <div className="w-100  p-3 float-right">
                  <ExpressAdvice {...props} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-8 col-sm-12 px-md-2 mb-2 pb-3">
            <div className="card">
              <SecondaryTabs {...props} events={events} />
            </div>
          </div>
        </div>
        <div className="row sticky-bottom">
          <div className="col-md-12">
            <TotalSection />
          </div>
          <div className="col-md-12">
            {buttons}
          </div>
        </div>
      </>
    );
  }

  if (role === "customer" || role === "contact") {
    return (
      <div className="row">
        <div className="col-md-12 mb-3 contract-header">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6 mb-2 contract-title">
              Contract<b className="pl-2">#{tracking_number}</b>
              <EnhancedCustomer customer={customer} />
            </div>
            {/* <div className="col-md-6 mb-2">
              <div className="contract-state">
                {transformLowdash(aasm_state)}
              </div>
            </div> */}
          </div>

          <div className="row">
            <ListGroup className="scooter-info" flush>
              <ListGroupItem className="scooter">
                <div className=" mb-2" onClick={toggle}>
                  <label>
                    View contract info{" "}
                    <Icon icon={toggledOn ? "chevron-up" : "chevron-down"} />
                  </label>
                  <Collapse isOpen={toggledOn}>
                    <Scooter scooter={scooter} keyTag={key_tag} />
                    <div className="mb-2 selectable">{contractInfo}</div>
                  </Collapse>
                </div>
              </ListGroupItem>
            </ListGroup>
          </div>

          <div className="card mb-3">
            <div className="col-12">
              <div className="row justify-content-between align-items-center">
                {props.currentContract.queue_position > 0 && (
                  <div className="col-auto px-0">
                    {Queue(props.currentContract.queue_position, "horizontal")}{" "}
                  </div>
                )}
                <div className={styleTrackerAndQueue}>
                  <label className="pb-3">
                    <b>Tracker</b>
                  </label>
                  <Timeline
                    state_position={props.currentContract.state_position}
                    contract_states={props.currentContract.contract_states}
                  />
                </div>
                {expressAdStates.includes(props.currentContract.aasm_state) && (
                  <div className="col-4 p-3 justify-content-center">
                    <ExpressAdvice {...props} />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <Scooter scooter={scooter} keyTag={key_tag} />
          {contractInfo}*/}

          <div className="row mb-3">
            <div className="col-md-12">
              <SecondaryTabs {...props} events={events} />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row white-bkg customer-fixed-bottom">
            <div className="col-md-7">
              <TotalSection />
            </div>
            <div className="col-md-5">{buttons}</div>
          </div>
        </div>
      </div>
    );
  }

  if (isSmallScreen) {
    return (
      <>
        <div className="row">
          <div className="col mb-2">
            <EnhancedCustomer customer={customer} />
          </div>

          <div className="col-12 mb-1">
            <div className="contract-state">{transformLowdash(aasm_state)}</div>
          </div>
          <ListGroup flush>
            <ListGroupItem>
              <div className="mb-2" onClick={toggle}>
                <label>
                  Contract details{" "}
                  <Icon icon={toggledOn ? "chevron-up" : "chevron-down"} />
                </label>
                <Collapse isOpen={toggledOn}>
                  <Scooter scooter={scooter} keyTag={key_tag} />
                  <div className="mb-2 selectable">{contractInfo}</div>
                </Collapse>
              </div>
            </ListGroupItem>
          </ListGroup>

          <div className="col-md-8 col-sm-12 px-md-2 mb-2">
            <div className="card">
              <SecondaryTabs events={events} {...props} />
            </div>
          </div>
          <div className="col-12 mb-2">
            <PrimaryTabs />
          </div>
        </div>
        <div className="row footer-staff">
          <div className="col-md-12 col-sm-12 px-0 ">{buttons}</div>
        </div>
      </>
    );
  }

  return (
    <div className="contract">
      <div className="col-md-12 col-sm-12 px-md-2 mb-3 contract-header">
        <div className="row justify-content-between align-items-center">
          <div className="col-md-8 mb-2 justify-content-between contract-title">
            <div>
              Contract <b>#{tracking_number}</b>
            </div>
            <div className="contract-state">{transformLowdash(aasm_state)}</div>
          </div>
          <div className="col-md-4 col-sm-12 mb-2">
            <EnhancedCustomer customer={customer} />
          </div>
        </div>

        <Scooter scooter={scooter} keyTag={key_tag} />
        {contractInfo}
      </div>
      <div className="row staff-contract-view">
        <div className="col-md-8 col-sm-12 contract-body">
          <SecondaryTabs {...props} events={events} />
        </div>
        <div className="col-md-4 col-sm-12 totals">
          <PrimaryTabs />
        </div>
      </div>
      <div className="row footer-staff">
        <div className="col-md-8 col-sm-12 " />
        <div className="col-md-4 col-sm-12 px-0">{buttons}</div>
      </div>
    </div>
  );
});

ContractDetailed.propTypes = propTypes;

export default ContractDetailed;
